// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__uCx6X","desktop-active":"styles_desktop-active__I+1Az","mobile-active":"styles_mobile-active__WQnlO"};